import { render, staticRenderFns } from "./software-price.vue?vue&type=template&id=cf7daa44&"
import script from "./software-price.vue?vue&type=script&lang=js&"
export * from "./software-price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports